import React from 'react';

export default function Choose() {
  return (
    <>
    <section className='mx-auto justify-center scroll-smooth duration-500 text-[#e0e0e0] lg:py-40 pt-5 bg-[#e4e4e4]'>
        <div className='mx-auto lg:px-10 sm:px-10 md:px-10 px-5 max-w-screen-2xl'>
            <div className='justify-center w-full mx-auto text-[#000]'>
                <h1 className='md:text-4xl text-xl mx-auto text-[#000] justify-center md:text-center'>
                    Why Choose Our Ultra-Fast EV Charging Network?
                </h1>
                <div className='md:flex grid-cols-3 md:gap-x-5 justify-between mx-auto md:pt-20'>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Speed
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Our ultra-fast chargers can replenish your EV's battery much quicker than standard charging stations, ensuring you're back on the road in the shortest possible time.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Accessibility
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Strategically located across key locations in the UK, our charging stations are easily accessible for both urban and long-distance EV drivers.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Sustainability
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Contributing to the reduction of carbon emissions, our network supports the UK's ambition to achieve net-zero by 2050, aligning with global sustainability targets.
                        </p>
                    </div>
                </div>
                <div className='md:flex grid-cols-4 mmd:gap-x-5 justify-between mx-auto md:pt-10'>
                    
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Innovation
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            We continuously invest in research and development to enhance our charging technology, ensuring our network remains at the cutting edge of the EV charging industry.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Rapid Charging
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Reducing charge times to merely 10 minutes, our 480 kW chargers are set to revolutionize user experience and accessibility for EV drivers.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Scalability and Customization
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Tailored to meet the specific needs of each location, our solutions are adaptable and scalable, ensuring they grow alongside your sustainable development efforts.
                        </p>
                    </div>
                    <div className='md:py-10 md:max-w-sm hover:bg-white duration-200 border-opacity-40 py-5 border-b border-[#d8bb6c] hover:translate-y-1 hover:px-5 md:mx-5 hover:text-black cursor-wait'>
                        <h1 className='font-semibold md:text-xl pt-5 text-lg'>
                            Increase asset value
                        </h1>
                        <p className='text-[#999] md:text-base text-sm pt-3 hover:text-black'>
                            Enhance the attractiveness and value of your properties, attracting users and investors seeking sustainable developments.
                        </p>
                    </div>
                </div>
                <div className='justify-center mx-auto w-full bg-[#dfdfdf] px-5 md:mt-10 mt-5'>
                    <div className='text-[#757575] max-w-screen-xl mx-auto justify-center md:py-20 py-10 text-center md:text-xl text-xs'>
                        <p>
                        Join us in accelerating the transition to sustainable transportation with Elite Crown' ultra-fast EV charging network – powering your journey, preserving our planet.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}